export enum FolderHeaderButtonTypes {
  NEW_FOLDER = 'newFolder',
  EDIT_FOLDER = 'editFolder'
}